import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ToastService } from './toast.service';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToastComponent {
  private readonly toastService = inject(ToastService);

  protected readonly toasts = this.toastService.toasts.asReadonly();

  protected dismiss(toastId: number): void {
    this.toastService.remove(toastId);
  }

  protected pause(toastId: number): void {
    this.toastService.pause(toastId);
  }

  protected resume(toastId: number): void {
    this.toastService.resume(toastId);
  }
}
